import http from './default'

export default class SearchService {
  static async search(firstName, lastName, phone, email, state) {
    const api = process.env.REACT_APP_APPLICANT_SERVICE_URL
    const params = { email, firstName, lastName, phone, state }
    return await http.get(`${api}/profiles`, params)
  }

  static async getApplications(profileId) {
    const api = process.env.REACT_APP_APPLICANT_SERVICE_URL
    const applications = await http.get(`${api}/applications/${profileId}`)
    return { applications, profileId }
  }

  static async getProfilesData(profileIds) {
    const api = process.env.REACT_APP_SESSION_SERVICE_URL
    const request = { profileIds: profileIds.map(el => Number(el)) }
    const response = await http.post(`${api}/profiles/_search`, request)
    return response.data
  }

  static async getAccounts(firstName, lastName, phone, email) {
    const profiles = await SearchService.search(
      firstName,
      lastName,
      phone,
      email,
    )

    const applications = await Promise.all(
      profiles.map(profile => SearchService.getApplications(profile.profileId)),
    )

    const profilesData = await SearchService.getProfilesData(
      profiles.map(el => el.profileId),
    )

    const getApplicationDate = app =>
      app.applications[0] ? app.applications[0].appliedDate : app.modifiedDate //getting first application because it comes sorted from server

    const sortByDate = (a, b) =>
      new Date(getApplicationDate(b)) - new Date(getApplicationDate(a))

    return profiles
      .map(profile => {
        const profileData = profilesData.profiles.find(
          p => p.profileId === Number(profile.profileId),
        )
        return {
          ...profile,
          applications: applications.find(
            a => a.profileId === profile.profileId,
          ).applications,
          hasCognitoAccountWithEmail: profileData.hasCognitoAccountWithEmail,
          hasCognitoAccountWithPhone: profileData.hasCognitoAccountWithPhone,
        }
      })
      .sort(sortByDate)
  }
}
